import { useQuery } from '@apollo/client';
import type { DealProviderConfig } from '@openx/components-deal/lib/utils/context/DealContext';
import type { UseFetchDealIdGroupInfoParams } from '@openx/components-deal/lib/utils/context/DealHookTypes';
import { GetDealGroupInfoDocument } from '../../../graphql/query/deals/GetDealGroupInfo.generated';

export const useFetchDealIdGroupInfo: DealProviderConfig['useFetchDealIdGroupInfo'] = ({
  dealIds,
}: UseFetchDealIdGroupInfoParams) => {
  const { data } = useQuery(GetDealGroupInfoDocument, {
    nextFetchPolicy: 'cache-only',
    skip: !dealIds?.length,
    variables: {
      deal_ids: dealIds,
    },
  });

  const { dealGroupInfo } = data || {};

  return {
    dealGroupInfo: dealGroupInfo ?? [],
  };
};
